// import logotipo from '../../../../../assets/logo.png'
import View from "../../../../../components/configPdf/View";
import Text from "../../../../../components/configPdf/Text";
import CustomTablePDF from "../../../../../components/configPdf/CustomTablePDF";
import { Page, Document, PDFViewer } from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { requestDefaulAuth } from "../../../../../http/httpRequest";
import { TitleTable } from "../../../../../components/configPdf/TitleTable";
import { formatDefaultDate } from "../../../../../utils/dateFormat";
import {
  LabelValueTablePdf,
  SectionAlmacenProductoCuadernoTablePdf,
  ValueTablePdf,
} from "../../../../../components/configPdf/CustomTableSectionPDF";

const CuadernoPdf = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const params = useParams();
  const dipatch = useDispatch();

  const getData = async () => {
    setLoading(true);
    await requestDefaulAuth(
      "get",
      `/cuaderno/${params.cuaderno_id}/fullData`,
      null,
      setData,
      dipatch
    );
    setLoading(false);
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.cuaderno_id]);
  const MyDoc = (
    <Document>
      <Page size="LETTER" style={{ padding: "10px" }}>
        {/* <Page size={{ width: 226.77, height: 'auto' }} style={{ padding: '10px' }}> */}
        <View alignItems="flex-start">
          <View
            width="75%"
            style={{ marginRight: "5px" }}
            flexDirection="column"
          >
            <View margin="auto">
              <Text bold fontSize="12px" style={{ letterSpacing: "2px" }}>
                CUADERNO DIARIO
              </Text>
            </View>
            <View>
              <Text>NOMBRE:</Text>
              <Text>{data?.cuadernoDetail?.usuario_nombre}</Text>
            </View>
            <TitleTable margin="1px 0px 0px 0px" textTitle="VENTAS" />
            <CustomTablePDF
              fields={[
                {
                  label: "NOMBRE DEL CLIENTE",
                  name: "cliente_nombre",
                  // type: 'date',
                  width: "16%",
                },
                {
                  label: "TCC 200Lts",
                  name: "tcc200",
                  width: "6%",
                  justifyContent: "flex-end",
                },
                {
                  label: "TV 200Lts",
                  name: "tv200",
                  width: "6%",
                  justifyContent: "flex-end",
                },
                {
                  label: "TCC 100Lts",
                  name: "tcc100",
                  width: "6%",
                  justifyContent: "flex-end",
                },
                {
                  label: "TV 100Lts",
                  name: "tv100",
                  width: "6%",
                  justifyContent: "flex-end",
                },
                {
                  label: "GAR. BS",
                  name: "monto_garantia",
                  width: "8%",
                  justifyContent: "flex-end",
                },
                {
                  label: "GAR. TRANS. BS",
                  name: "monto_garantia_transferencia",
                  width: "10%",
                  justifyContent: "flex-end",
                },
                {
                  label: "EFEC. BS",
                  name: "efectivo_total",
                  width: "10%",
                  justifyContent: "flex-end",
                },
                {
                  label: "TRANSF BS",
                  name: "transferencia_total",
                  width: "10%",
                  justifyContent: "flex-end",
                },
                {
                  label: "POR COBRAR BS",
                  name: "deuda_total",
                  width: "10%",
                  justifyContent: "flex-end",
                },
                {
                  label: "OBS.",
                  name: "obs",
                  width: "12%",
                  // justifyContent: 'flex-start'
                },
              ]}
              border={{ right: true, bottom: true, left: true }}
              data={data.ventasPrincipal}
            />
            <View
              border={{ right: true, bottom: true, left: true }}
              width="100%"
            >
              <View border={{ right: true }} width="16%">
                <Text bold>Subtotal</Text>
              </View>
              <View border={{ right: true }} width="24%">
                <Text bold> </Text>
              </View>
              <View
                border={{ right: true }}
                width="8%"
                justifyContent="flex-end"
              >
                <Text bold>{data.totalGarantiaPrincipal}</Text>
              </View>
              <View
                border={{ right: true }}
                width="10%"
                justifyContent="flex-end"
              >
                <Text bold>{data.totalGarantiaTransfPrincipal}</Text>
              </View>
              <View
                border={{ right: true }}
                width="10%"
                justifyContent="flex-end"
              >
                <Text bold>{data.totalCobradoPrincipal}</Text>
              </View>
              <View
                border={{ right: true }}
                width="10%"
                justifyContent="flex-end"
              >
                <Text bold>{data.totalCobradoTransfPrincipal}</Text>
              </View>
              <View
                border={{ right: true }}
                width="10%"
                justifyContent="flex-end"
              >
                <Text bold>{data.totalPorCobrarPrincipal}</Text>
              </View>
              <View
                border={{ right: false }}
                width="12%"
                justifyContent="flex-end"
              >
                <Text bold></Text>
              </View>
            </View>
            <TitleTable margin="3px 0px 0px 0px" textTitle="OTRAS VENTAS" />
            <CustomTablePDF
              fields={[
                {
                  label: "NOMBRE DEL CLIENTE",
                  name: "cliente_nombre",
                  // type: 'date',
                  width: "18%",
                },
                {
                  label: "PRODUCTO",
                  name: "producto_nombre",
                  width: "21%",
                },
                
                {
                  label: "CANTIDAD",
                  name: "cantidad",
                  width: "14%",
                  justifyContent: "flex-end",
                },
                {
                  label: "COBRADO Bs.",
                  name: "efectivo_total",
                  width: "10%",
                  justifyContent: "flex-end",
                },
                {
                  label: "TRANSF BS",
                  name: "transferencia_total",
                  width: "10%",
                  justifyContent: "flex-end",
                },
                {
                  label: "POR COBRAR BS",
                  name: "deuda_total",
                  width: "10%",
                  justifyContent: "flex-end",
                },
                {
                  label: "OBS.",
                  name: "obs",
                  width: "17%",
                  // justifyContent: 'flex-start'
                },
              ]}
              border={{ right: true, bottom: true, left: true }}
              data={data.ventasOtros}
            />
            <View
              border={{ right: true, bottom: true, left: true }}
              width="100%"
            >
              <View border={{ right: true }} width="18%">
                <Text bold>Subtotal</Text>
              </View>
              <View border={{ right: true, bottom: false }} width="21%">
                <Text bold> </Text>
              </View>
              <View
                border={{ right: true }}
                width="14%"
                justifyContent="flex-end"
              >
                <Text bold> </Text>
              </View>
              <View
                border={{ right: true }}
                width="10%"
                justifyContent="flex-end"
              >
                <Text bold>{data.totalCobradoOtros}</Text>
              </View>
              <View
                border={{ right: true }}
                width="10%"
                justifyContent="flex-end"
              >
                <Text bold>{data.totalCobradoTransfOtros}</Text>
              </View>
              <View
                border={{ right: true }}
                width="10%"
                justifyContent="flex-end"
              >
                <Text bold>{data.totalPorCobrarOtros}</Text>
              </View>
            </View>
            <TitleTable textTitle="ENVASES RECOGIDOS" />
            <CustomTablePDF
              fields={[
                {
                  label: "NOMBRE DEL CLIENTE",
                  name: "envaseDeudorDetalles",
                  // type: 'date',
                  width: "23%",
                },
                {
                  label: "FECHA DEUDA",
                  name: "fecha_deuda",
                  dateConvert: formatDefaultDate,
                  width: "17%",
                },
                {
                  label: "TIPO",
                  name: "metodo_intercambio",
                  width: "13%",
                  // justifyContent: 'flex-end'
                },
                {
                  label: "TV 200Lts",
                  name: "tv200",
                  width: "8%",
                  justifyContent: "flex-end",
                },
                {
                  label: "TV 100Lts",
                  name: "tv100",
                  width: "8%",
                  justifyContent: "flex-end",
                },
                {
                  label: "GARANTIA Bs.",
                  name: "monto",
                  width: "13%",
                  justifyContent: "flex-end",
                },
                {
                  label: "OBS.",
                  name: "obs",
                  width: "18%",
                  justifyContent: "flex-end",
                },
              ]}
              border={{ right: true, bottom: true, left: true }}
              data={data.envasesRecogidos}
            />
            <TitleTable textTitle="ÁREA DE COBRANZAS" />
            <CustomTablePDF
              fields={[
                {
                  label: "NOMBRE DEL CLIENTE",
                  name: "deudorDetalles",
                  // type: 'date',
                  width: "22%",
                },
                {
                  label: "FECHA DEUDA",
                  name: "fecha_deuda",
                  width: "15%",
                  dateConvert: formatDefaultDate,
                },
                {
                  label: "Metodo Pago",
                  name: "metodo_pago",
                  width: "15%",
                  justifyContent: "flex-end",
                },
                {
                  label: "MONTO COBRADO Bs.",
                  name: "montoT",
                  width: "13%",
                  justifyContent: "flex-end",
                },
                {
                  label: "POR COBRAR Bs.",
                  name: "saldo",
                  width: "13%",
                  justifyContent: "flex-end",
                },
                {
                  label: "OBSERVACIONES",
                  name: "obs",
                  width: "22%",
                },
              ]}
              border={{ right: true, bottom: true, left: true }}
              data={data.cobranzas}
            />
            <TitleTable textTitle="TESORERÍA" />
            <View
              border={{ bottom: true, top: true, left: true }}
              // alignItems='flex-end'
            >
              <View width="30%" border={{ right: true }} flexDirection="column">
                <LabelValueTablePdf
                  headerTitle="VENTAS, GAR. Y COBRANZAS"
                  fields={[
                    {
                      label: "VENTAS",
                      value: data.totalVentas,
                      widthLabel: "50%",
                      widthName: "50%",
                    },
                    {
                      label: "OTROS",
                      value: data.totalCobradoOtros,
                      widthLabel: "50%",
                      widthName: "50%",
                    },
                    {
                      label: "COBROS",
                      value: data.totalCobranzas,
                      widthLabel: "50%",
                      widthName: "50%",
                    },
                    {
                      label: "GAR.",
                      // value: data.garantias,
                      value: data.totalGarantiaPrincipal,
                      widthLabel: "50%",
                      widthName: "50%",
                    },
                    {
                      label: "GAR. TRANS",
                      // value: data.garantias,
                      value: data.totalGarantiaTransfPrincipal,
                      widthLabel: "50%",
                      widthName: "50%",
                    },
                  ]}
                  border={{ bottom: true }}
                />
                <View
                  width="100%"
                  style={{ backgroundColor: "rgba(30,95,160,.2)" }}
                  border={{ bottom: true }}
                >
                  <View width="50%" border={{ right: true }}>
                    <Text bold>Total</Text>
                  </View>
                  <View width="50%" justifyContent="flex-end">
                    <Text bold>{data.totalVentasGarantiasCobranzas}</Text>
                  </View>
                </View>
              </View>
              <View width="30%" border={{ right: true }} flexDirection="column">
                <ValueTablePdf
                  headerTitle="GASTOS"
                  fields={[
                    {
                      name: "estado_gasto_nombre",
                      width: "50%",
                    },
                    {
                      name: "monto",
                      width: "50%",
                      justifyContent: "flex-end",
                    },
                  ]}
                  border={{ bottom: true }}
                  data={data.gastos}
                  startExtraData={{
                    label: "Dev. Gar.",
                    value: data.devolucionGarantias,
                  }}
                />
                <View
                  width="100%"
                  style={{ backgroundColor: "rgba(30,95,160,.2)" }}
                  border={{ bottom: data.gastos?.length > 3 ? false : true }}
                >
                  <View width="50%" border={{ right: true }}>
                    <Text bold>Total Gastos</Text>
                  </View>
                  <View width="50%" justifyContent="flex-end">
                    <Text bold>{data.totalGastos}</Text>
                  </View>
                </View>
              </View>
              <View
                width="40%"
                border={{ right: true }}
                // justifyContent='flex-end'
                flexDirection="column"
              >
                <LabelValueTablePdf
                  headerTitle="DINERO ENTREGADO"
                  fields={[
                    {
                      label: "BILLETES",
                      value: data.billetes,
                      widthLabel: "60%",
                      widthName: "40%",
                    },
                    {
                      label: "MONEDAS",
                      value: data.monedas,
                      widthLabel: "60%",
                      widthName: "40%",
                    },
                    {
                      label: "DOLARES",
                      value: data.dolares,
                      widthLabel: "60%",
                      widthName: "40%",
                    },
                    {
                      label: "FALTANTE",
                      value: data.cuadernoDetail?.efectivo_faltante,
                      widthLabel: "60%",
                      widthName: "40%",
                    },
                    {
                      label: "SOBRANTE",
                      value: data.cuadernoDetail?.efectivo_sobrante,
                      widthLabel: "60%",
                      widthName: "40%",
                    },
                  ]}
                />

                <View
                  width="100%"
                  style={{ backgroundColor: "rgba(30,95,160,.2)" }}
                >
                  <View width="60%" border={{ right: true }}>
                    <Text bold>Total Efectivo</Text>
                  </View>
                  <View width="40%" justifyContent="flex-end">
                    <Text bold>
                      {(
                        parseFloat(
                          (data.cuadernoDetail?.efectivo_total || "0")
                            .toString()
                            .replace(/\./g, "")
                            .replace(",", ".")
                        ) +
                        parseFloat(
                          (data.cuadernoDetail?.garantias_total || "0")
                            .toString()
                            .replace(/\./g, "")
                            .replace(",", ".")
                        )
                      ).toFixed(2)}
                    </Text>
                  </View>
                </View>
                <View
                  width="100%"
                  style={{ backgroundColor: "rgba(30,95,160,.2)" }}
                >
                  <View width="60%" border={{ right: true }}>
                    <Text bold>Total Transferencias</Text>
                  </View>
                  <View width="40%" justifyContent="flex-end">
                    <Text bold>
                      {" "}
                      {(
                        parseFloat(
                          (data.cuadernoDetail?.transferencia_total || "0")
                            .toString()
                            .replace(/\./g, "")
                            .replace(",", ".")
                        ) +
                        parseFloat(
                          (
                            data.cuadernoDetail
                              ?.garantias_total_transferencia || "0"
                          )
                            .toString()
                            .replace(/\./g, "")
                            .replace(",", ".")
                        )
                      ).toFixed(2)}
                    </Text>
                  </View>
                </View>
                <View
                  width="100%"
                  style={{ backgroundColor: "rgba(30,95,160,.2)" }}
                >
                  <View width="60%" border={{ right: true }}>
                    <Text bold>Total</Text>
                  </View>
                  <View width="40%" justifyContent="flex-end">
                    <Text bold>
                      {(
                        parseFloat(
                          (data.cuadernoDetail?.efectivo_total || "0")
                            .toString()
                            .replace(/\./g, "") // quita separadores de miles
                            .replace(",", ".") // convierte coma decimal en punto
                        ) +
                        parseFloat(
                          (data.cuadernoDetail?.garantias_total || "0")
                            .toString()
                            .replace(/\./g, "")
                            .replace(",", ".")
                        ) +
                        parseFloat(
                          (data.cuadernoDetail?.transferencia_total || "0")
                            .toString()
                            .replace(/\./g, "")
                            .replace(",", ".")
                        ) +
                        parseFloat(
                          (
                            data.cuadernoDetail
                              ?.garantias_total_transferencia || "0"
                          )
                            .toString()
                            .replace(/\./g, "")
                            .replace(",", ".")
                        )
                      ).toFixed(2)}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          {/* ------------------------------- */}
          <View
            width="25%"
            style={{ marginRight: "5px", color: "red" }}
            flexDirection="column"
          >
            <View>
              <Text
                bold
                fontSize="12px"
                style={{ letterSpacing: "2px", color: "red" }}
              >
                N° {data.cuadernoDetail?.codigo}
              </Text>
            </View>
            <View>
              <Text>FECHA:</Text>
              <Text>{formatDefaultDate(data?.cuadernoDetail?.createdAt)}</Text>
            </View>
            {/* {
              data?.almacenes?.map((alm, idx) => (
                <SectionAlmacenCuadernoTablePdf
                  key={idx}
                  margin={`${idx < 1 ? '1' : '5'}px 0px 0px 0px`}
                  titleTable={alm.label}
                  saldoAnterior={alm.saldo_anterior}
                  cargadoEnElDia={alm.cantidad_ingreso}
                  subTotal={alm.cantidad_parcial}
                  venta={alm.cantidad_egreso}
                  saldo={alm.cantidad_total}
                />
              ))
            } */}
            {data?.tcc200 && (
              <SectionAlmacenProductoCuadernoTablePdf
                margin={`5px 0px 0px 0px`}
                titleTable={"TURRILES CON CONTENIDO - 200LTS"}
                data={data?.tcc200}
                rol={data?.cuadernoDetail?.Rols}
              />
            )}
            {data?.tv200 && (
              <SectionAlmacenProductoCuadernoTablePdf
                margin={`5px 0px 0px 0px`}
                titleTable={"TURRILES VACÍOS - 200LTS"}
                data={data?.tv200}
                rol={data?.cuadernoDetail?.Rols}
              />
            )}
            {data?.tcc100 && (
              <SectionAlmacenProductoCuadernoTablePdf
                margin={`5px 0px 0px 0px`}
                titleTable={"TURRILES CON CONTENIDO - 100LTS"}
                data={data?.tcc100}
                rol={data?.cuadernoDetail?.Rols}
              />
            )}
            {data?.tv100 && (
              <SectionAlmacenProductoCuadernoTablePdf
                margin={`5px 0px 0px 0px`}
                titleTable={"TURRILES VACÍOS - 100LTS"}
                data={data?.tv100}
                rol={data?.cuadernoDetail?.Rols}
              />
            )}
          </View>
        </View>
        <View margin="20px 0 0 0" justifyContent="center">
          <View width="25%" style={{ marginRight: "5px" }}>
            <View width="100%" flexDirection="column">
              <View justifyContent="center">
                <Text>...........................................</Text>
              </View>
              <View justifyContent="center">
                <Text>RECEPCIONADO</Text>
              </View>
            </View>
          </View>
          <View width="25%" style={{ marginRight: "5px" }}>
            <View width="100%" flexDirection="column">
              <View justifyContent="center">
                <Text>...........................................</Text>
              </View>
              <View justifyContent="center">
                <Text>VENDEDOR</Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );

  return loading ? (
    <div className="mx-16 my-12">
      <div>
        <svg
          aria-hidden="true"
          className="inline w-14 h-14 text-gray-200 animate-spin dark:text-gray-500 dark:fill-yellow-500 fill-yellow-600"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  ) : (
    <PDFViewer
      style={{
        width: 900,
        height: window.innerHeight - 100,
      }}
      children={MyDoc}
    />
  );
};

export default CuadernoPdf;
